<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="pb-3">Ativar módulo <code>Validação</code></h2>

          <p>Para ativar o módulo de <strong>Validação de Ingressos</strong> do aplicativo <u>Easytick</u> siga os passos:</p>

          <ol>
            <li class="pb-3">
              Abra o aplicativo <u>Easytick</u>;
              <ul class="mt-2">
                <li>Caso não tenha instalado o aplicativo siga as <b-link :to="{ name: 'OrganizerApp' }">instruções de instalação</b-link>.</li>
              </ul>
            </li>
            <li class="pb-3">Na primeira tela do aplicativo toque no botão <code>VALIDAR INGRESSOS</code>;</li>
            <li class="pb-3">Leia o QRCode abaixo usando o aplicativo <u>Easytick</u>; ou</li>
            <li class="pb-3">Use o botão abaixo do QRCode para copiar o código de ativação e cole no Aplicativo;</li>
          </ol>


          <hr>

          QRCode para ativar módulo <code>Validação</code>.
          <br>
          <canvas ref="canvas"></canvas>
          <br>

          <hr>

          Botão para copiar o código do QRCode para ativar módulo <code>Validação</code>.

          <b-input-group class="mt-4">
            <b-input-group-prepend>
              <b-button
                v-b-tooltip.hover
                @click="copyQRCodeContent">
                <icon name="copy" class="mx-0"></icon>
                Copiar código de ativação
              </b-button>
            </b-input-group-prepend>
            <b-form-input size="md"  v-model="qrcodeContent" disabled></b-form-input>
          </b-input-group>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import QRCode from 'qrcode'
import copy from 'copy-to-clipboard'

export default {
  name: 'OrganizerAppValidate',
  data () {
    return {
      event: {},
      qrcodeContent: ''
    }
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    await this.getEvent()
    this.handleQrcode()
  },
  updated () {
    this.handleQrcode()
  },
  methods: {
    async getEvent () {
      try {
        let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'
        let res = await this.$http.get(url)
        this.event = res.body
      } catch (e) {
        console.error(e)
      }
    },
    handleQrcode () {
      this.qrcodeContent = this.$session.get('login') + ";" + this.event.token
      let canvas = this.$refs.canvas
      let opt = { errorCorrectionLevel: 'H', width: 250 }
      QRCode.toCanvas(canvas, this.qrcodeContent, opt, function (error) {
        if (error) console.error(error)
      })
    },
    copyQRCodeContent () {
      copy(this.qrcodeContent)

      this.$bvToast.toast(`Código de ativação copiado com sucesso`, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: 'success'
      })
    },
  }
}
</script>
